module.exports = __webpack_public_path__ + "static/media/custom-stickers.ac09e684.JPG";